var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"info-box flex flex-align-center"},[_c('SBIcon',{staticClass:"mr-3",attrs:{"icon":_vm.SBIconList.TRIANGLE_EXCLAMATION,"color":_vm.SBColors.$blackPrimary,"size":12}}),_vm._t("content")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }